import {inject, IReactComponent} from 'mobx-react';
import {StartWithModes} from './component';

import './styles.scss';

const mapStoresToProps = (stores: any) => ({
    startWithModesController: stores.inviteStore?.inviteFlowManager?.startWithModesController,
    translate: stores.inviteStore?.localizationService?.translate?.bind(stores.inviteStore.localizationService)
});

const StartWithModesComponent = inject(mapStoresToProps)(StartWithModes) as IReactComponent;

export default StartWithModesComponent;
